<template>
<div>
  <!--<button id="playBtn" style="position: fixed; top:.75vh; left:.75vh; padding:calc(min(.25vh,5px))!important; font-size:calc(min(1.5vh,1rem)!important; background-color:#ffffff; width: 7ch; border:none; border-radius: 2px;"  @click="togglePlay">{{isPlaying}}</button>-->
  <Scrollama  :offset="0.5" v-for="(sectionContents, sectionTitle, index) in sections" :key="sectionTitle" @step-enter="stepEnterHandler">
    <div slot="graphic" class="section-header">
      <div>{{ sectionTitle }}</div>
    </div>
      <component :ref="`comp-${index}`" :data-section="index" class="step section" :is="sectionContents.component" v-bind:content="sectionContents.content" v-bind:stepSpeed="sectionContents.speed"></component>
  </Scrollama>
</div>
</template>

<script>
import "intersection-observer";
import Scrollama from "vue-scrollama";
import MapScroller from "@/components/MapScroller.vue";
import BaseSection from "@/components/BaseSection.vue";

/*
function smoothScroll( elem, options ) {
  return new Promise( (resolve) => {
    let same = 0;
    let lastPos = null;
    const scrollOptions = Object.assign( { behavior: 'smooth' }, options );
    elem.scrollIntoView( scrollOptions );
    requestAnimationFrame( check );   
    function check() {
      const newPos = elem.getBoundingClientRect().top;
      
      if( newPos === lastPos ) {
        if(same ++ > 4) {
          return resolve();
        }
      }
      else {
        same = 0;
        lastPos = newPos;
      }
      requestAnimationFrame(check);
    }
  });
}
*/
export default {
  name: "App",
  components: {
    Scrollama,
    MapScroller,
    BaseSection
  },
  mounted(){
    //this.curSection=0;
    //this.playing=false;    
  },
  created () {
    //window.addEventListener('mousewheel', this.handleScroll);
    //window.addEventListener('mousedown', this.handleScroll);
  },
  destroyed () {
    //window.removeEventListener('mousewheel', this.handleScroll);
    //window.removeEventListener('mousedown', this.handleScroll);
  },
  methods:{
    stepEnterHandler({ element, index, direction }){
      //this.curSection=parseInt(element.dataset.section);
    },
    handleScroll(e){
      //if(this.playing && !(e.target.id==='playBtn')) this.togglePlay();
    },
    
    async togglePlay(){
      /*
      this.playing=!this.playing;
      
      if(!this.playing || this.curSection >= this.sections.length){
        window.clearTimeout(this.timer)
      }else{       
        let run = async ()=>{
          let tgt = this.step()
          await smoothScroll(tgt);
          this.timer = window.setTimeout(run,3000);
        }        
        await run();       
      }
*/
    },
    
    step(){
      /*
      let curComp = this.$refs[`comp-${this.curSection}`]
      if(curComp && curComp[0]){
        let nid = curComp[0].currentStep+1;
        let nxtnar = curComp[0].$refs[`narr-${nid}`]
        if(nxtnar){
          return nxtnar[0]
        }else if(nid>=curComp[0].steps.length){
          let nxtComp = this.$refs[`comp-${this.curSection+1}`]
          if(nxtComp){            
            let nar = nxtComp[0].$refs[`narr-${nxtComp[0].currentStep}`]
            if(nar){
              return nar[0]              
            }else{
              //console.log(this.curSection,curComp);               
            }
          }else{
          }
        }else{
          //console.log("not greater than length")
        }
      }else{
        //console.log("not curcomp or zero")
      }
      */
    }
  },
  computed:{
    isPlaying(){
      return this.playing?"| |":">"
      }
    },
  data() {
    return {
      curSection:0,
      timer: null,
      playing: false,
      sections:{
        'Our homes, our carbon':{component:'BaseSection',content:{assets: [...Array(13).keys()].map(id=>require(`../assets/house/${id}.svg`)),
                                                                  narrative: ([...Array(5).fill('42% of energy emissions come from decisions we control in our households.'),
                                                                               ...Array(8).fill('With a few changes to this home infrastructure, we can eliminate these emissions completely.'),
                                                                               'Using existing technology, we can run our homes on 100% decarbonized electricity.',
                                                                               'And if we do it right, save a bunch of money in the process.'                                                             
                                                                              ]),
                                                                  speed: 1
                                                                 }
                                },
        'Current energy expenditures':{component:'BaseSection',content:{assets: ([...Array(4).keys()]).map(id=>require(`../assets/savings/${id}.svg`)),
                                                                        narrative: (['Today, energy is a significant part of the average U.S. household budget.',
                                                                                     'We currently spend more on electricity than education...',
                                                                                     'More on natural gas than dentistry...',
                                                                                     'And more on gasoline than meat, poultry, fish, fruits, and vegetables...combined.'                                                                                 
                                                                                    ]),
                                                                        speed: 1
                                                                       }
                                      },
        
        'Costs are falling, fast.':{component:'BaseSection',content:{assets: ([...Array(26).keys()]).map(id=>require(`../assets/learning/${id}.svg`)),
                                                                         narrative: ([...Array(19).fill('The technology required for decarbonization used to be expensive, but has gotten exponentially cheaper, year after year.'),
                                                                                      ...Array(7).fill('These prices will continue to fall if we make the commitment to scaling renewables.')
                                                                                     ]),
                                                                         speed: 10
                                                                        }
                                       },
        
        
        'Mapping it all out':{component:'MapScroller',content:{narrative: (['We can see current energy expenditures on this map, with high costs in regions with large heating bills, lots of driving, or expensive fuels.  The average household spends about $4,500 per year on gasoline, natural gas, electricity, and fuel oil.',
                                                                            'Converting to electric is possible today, but is an expensive proposition for a single household, especially for those with big energy needs.  Under business as usual, the average household would pay an extra $5,000 per year to cut out fossil fuels.',
                                                                            
                                                                            'With key changes to building codes, regulations, financing, and the electricity market, however, the economics can be flipped.  Under these conditions, the average American household can actually save about $1,200 by going electric.',
                                                                            'If we add industrial scale, and lower, federally-guaranteed interest rates, people would be saving money in every zip-code.  The average household saves $2,500, and some over $4,000.',
                                                                            '',
                                                                           ]),
                                                               speed: 1                                                               
                                                              }
                             },
        'What about jobs?':{component:'BaseSection',content:{assets: ([...Array(1).keys()]).map(id=>require(`../assets/jobs/${id}.svg`)),
                                                             narrative: ([
                                                               'This household transformation will also create about 7.7 million new jobs across the U.S.',
                                                             ]),
                                                             speed: 1
                                                            }
                           },                                                                                           
      }
    }
  }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style scoped>
  .narrative {
    position:sticky;
    top:7%!important;
    left: calc(50vw - 30ch);
    font-size: calc(min(min(2.5vh,32px),2vw));
    border: 4px solid  #1e2343;
    z-index:10000;
    border-radius:6px;
    font-weight: bold;
    width:60ch!important;
    margin: 0!important;
    padding: 2vw!important;
    background-color:rgba(255,255,255,.876);
}

.fixer{
    position: fixed;
    left: calc(50vw - 30ch);
    opacity:1!important;
}

.hidden{
    opacity:0;
    visibility:hidden;
}

.customstep {
    height: 100vh; 
    z-index:-1000;    
}

</style>
